<!-- vertical-layout -->
<ng-container *ngIf="coreConfig.layout.type === 'vertical'">
  <vertical-layout></vertical-layout>
</ng-container>
<!-- / vertical-layout -->

<!-- horizontal-layout -->
<ng-container *ngIf="coreConfig.layout.type === 'horizontal'">
  <horizontal-layout></horizontal-layout>
</ng-container>
<!-- / horizontal-layout -->

<!-- theme customizer -->
<core-sidebar name="themeCustomizer" class="customizer d-none d-md-block" [invisibleOverlay]="true"
  *ngIf="coreConfig.layout.customizer">
  <a class="customizer-toggle d-flex align-items-center justify-content-center"
    (click)="toggleSidebar('themeCustomizer')">
    <span [data-feather]="'settings'" [class]="'spinner'"></span>
  </a>
  <core-theme-customizer></core-theme-customizer>
</core-sidebar>
<!-- / theme customizer -->

<!-- Modal Error -->
<ng-template #modalError let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="myModalLabel160">Error en la solicitud</h5>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <h6>Total de errores: {{errors.all.length}}</h6>
    <h6>Ocasionado por: <h6 class="font-weight-normal">{{errors.current.by}}</h6></h6>
    <h6>Problema: <h6 class="font-weight-normal">{{errors.current.problem}}</h6> </h6>
    <h6>Solución: <h6 class="font-weight-normal">{{errors.current.solution}}</h6> </h6>
    <div class="d-flex flex-row justify-content-center" *ngIf="errors.all.length > 1">
      <div class="btn-group" role="group" aria-label="Group">
        <button type="button" class="btn btn-icon btn-lg btn-flat-danger" rippleEffect (click)="changeError('back')">
          <span [data-feather]="'arrow-left'"></span>
        </button>
        <button type="button" class="btn btn-icon btn-flat-danger" disabled rippleEffect>
        </button>
        <button type="button" class="btn btn-icon btn-lg btn-flat-danger" rippleEffect (click)="changeError('next')">
          <span [data-feather]="'arrow-right'"></span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modal.close('Accept click')" rippleEffect>
      Aceptar
    </button>
  </div>
</ng-template>
<!-- / Modal Error -->

<!-- Modal Error -->
<ng-template #modalTicket let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="myModalLabel160">Error durante la ejecución de su solicitud.</h5>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <h6>Ticket: {{ticket}}</h6>
    Se ha generado un ticket de soporte, si desea más información entregué su ticket a Journey Solution Center.
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-info" (click)="modal.close('Accept click')" rippleEffect>
      Aceptar
    </button>
  </div>
</ng-template>
<!-- / Modal Error -->